import React, { useState, useEffect } from 'react';
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, useNavigate  } from 'react-router-dom';
import {config} from "../../shared/config";
import * as util from '../../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import ShowError from "../../shared/ShowError";
import { Col, Container, Row } from 'react-bootstrap';
import Laoding from '../../shared/Laoding';
import { InputTextarea } from 'primereact/inputtextarea';

export default function BillDescriptions(props) {
    const navigate = useNavigate();
    const [redirectUrl, setRedirectUrl] = useState("");
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [saving, setSaving] = useState(false);
    const [descriptions, setDescriptions] = useState(null);

    useEffect(() => {
        var params = {
            param1:"", 
            param2:"", 
            param3:"", 
            param4:"", 
            param5:"", 
        };
        var url = config.Server+`/basic/bill-print/parameters/get`;
        var ds = ["", "", "", "", ""];
        
        axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                response = response.data;
                for(var i=0;i<response.descriptions.length;i++){
                    ds[i] = response.descriptions[i];
                }
                setDescriptions(ds);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                setDescriptions(ds);
                //setLoading(false);
            }
        })
        .catch(error => {
            console.log("error is>", error)
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            setDescriptions(ds);
            //setLoading(false);
        });
    }, []);
    const onInputChange = function(e, ind){
        var val = '';
        val = (e.target && e.target.value) || '';
        var ds = [...descriptions];
        ds[ind] = val;
        setDescriptions(ds);
    }
    const checkDataEntry = function(){
        return true;
    }
    const saveItem = function(){
        if (!checkDataEntry()) return;
        var params = {
            login: util.getLoginDto(), descriptons: descriptions
        };
        setSaving(true);
        var url = config.Server + `/basic/setting/bill-print/fix-texts`;
        axios
        .post(url, params)
        .then(res => {
            var response = res.data;
            if (response.state === "ok") {
                setErrorMessage("با موفقیت ثبت گردید");
                setErorVisible(true);
                setSaving(false);
                //setRedirectUrl("/home")
            }
            else {
                setErrorMessage(response.message);
                setErorVisible(true);
                setSaving(false);
            }
        })
        .catch(error => {
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            setSaving(false);
        });
    }

    return(
        (redirectUrl != "")?
        <>
            <Navigate to={redirectUrl} replace={false}  />
        </>
        :descriptions == null?
        <>
            <Row>
                <Col className="d-flex justify-content-center align-items-center" style={{height:"calc(100vh - 70px)"}}>
                    <Laoding showLable={true} label="در حال دریافت متن های صورتحساب..." />
                </Col>
            </Row>
            <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
        </>
        :
        <>
            <div style={{textAlign:"center", padding:"5px", backgroundColor:"#ccc", marginTop:"10px", borderTopRightRadius:"5px", borderTopLeftRadius:"5px"}}>
                متن های ثابت صورتحساب
            </div>
            {
                descriptions.map((d, dInd)=>{
                    return(
                        <Row style={{margin:"0px", padding:"0px"}}>
                            <Col md={12} style={{marginTop:"25px"}}>
                                <FloatLabel>
                                    <InputTextarea value={descriptions[dInd]} onChange={(e)=>{onInputChange(e, dInd)}} id={"text_" + dInd} keyfilter="" maxLength={1000} className="p-inputtext-lg" style={{width:"100%", height:"80px", textAlign:"right", direction:"rtl"}} />
                                    <label htmlFor={"text_" + dInd}>متن {String(dInd+1)}</label>
                                </FloatLabel>                                                    
                            </Col>
                        </Row>
                    )
                })
            }
            <Row style={{padding:"0px", margin:"20px 0px 0px 0px", position:"relative"}}>                
                <Col className="d-flex justify-content-center align-items-center" style={{marginBottom:"150px"}}>
                    <Button severity="success" onClick={()=>{saveItem()}} style={{borderRadius:"5px"}} loading={saving} iconPos="right" icon="pi pi-check">&nbsp;&nbsp;ثبت متن ها&nbsp;&nbsp;</Button>
                </Col>
            </Row>
            <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
        </>
    )
}